import swal from "sweetalert";

const deleteGroupSwal = async () => {
  return swal({
    title: "Delete Group?",
    text: "Are you sure you want to delete this group? If you proceed, it will also be deleted from TLMS.",
    content: {
      element: "div",
      attributes: {
        innerHTML: `
         <p style="text-align: left;font-size: 14px;">Select Deletion Type</p>  
        <div style="text-align: left; font-size: 16px;">
            <label style="display: block; margin-bottom: 10px;">
              <input type="radio" name="deleteOption" value="onlyGroup" checked style="margin-right: 5px;" />
              Delete only group
            </label>
            <label style="display: block; margin-bottom: 10px;">
              <input type="radio" name="deleteOption" value="withMembers" style="margin-right: 5px;" />
             Delete the group along with its associated members
            </label>
          </div>
        `,
      },
    },
    buttons: {
      cancel: {
        text: "Cancel",
        value: null,
        visible: true,
        className: "btn-secondary",
        closeModal: true,
      },
      confirm: {
        text: "Delete",
        value: true,
        visible: true,
        className: "btn-danger",
        closeModal: false, // Prevent closing until we fetch selected value
      },
    },
    dangerMode: true,
  }).then((confirm) => {
    if (confirm) {
      const selectedOption = document.querySelector('input[name="deleteOption"]:checked').value;
      swal.close(); // Close the swal popup manually
      return selectedOption; // Return the selected option
    }
    return null;
  });
};

export default deleteGroupSwal;
